import { apiClient } from "../../../api/client";
import { ApiResponse } from "../../../types";
import {
  CadastroInfo,
  ManagerVerbs,
  Message,
  WhatsAppApiRequest,
} from "../types";

const STAGE = process.env.REACT_APP_STAGE || "dev";

export const whatsappService = {
  async getMessagesByTimestamp(
    clientName: string,
    ops: string,
    start: number,
    end: number
  ): Promise<ApiResponse<Message[]>> {
    const request: WhatsAppApiRequest = {
      clientName,
      verb: ManagerVerbs.GetMessagesByTimestamp,
      start,
      end,
      ops,
    };

    return apiClient.postWhatsApp<Message[]>(
      `/whatsapp-public-api-${STAGE}/manager`,
      request
    );
  },

  async getMessagesByPhoneAndTimestamp(
    clientName: string,
    phone: string,
    ops: string,
    start: number,
    end: number
  ): Promise<ApiResponse<Message[]>> {
    const request: WhatsAppApiRequest = {
      clientName,
      phone,
      verb: ManagerVerbs.GetMessagesByPhoneAndTimestamp,
      start,
      end,
      ops,
    };

    return apiClient.postWhatsApp<Message[]>(
      `/whatsapp-public-api-${STAGE}/manager`,
      request
    );
  },

  async getUserState(
    clientName: string,
    phone: string,
    ops: string
  ): Promise<ApiResponse<{ userState: string }>> {
    const request: WhatsAppApiRequest = {
      clientName,
      phone,
      verb: ManagerVerbs.GetUserState,
      ops,
    };

    return apiClient.postWhatsApp<{ userState: string }>(
      `/whatsapp-public-api-${STAGE}/manager`,
      request
    );
  },

  async getUserCursor(
    clientName: string,
    phone: string,
    ops: string
  ): Promise<ApiResponse<{ cursor: string }>> {
    const request: WhatsAppApiRequest = {
      clientName,
      phone,
      verb: ManagerVerbs.GetUserCursor,
      ops,
    };

    return apiClient.postWhatsApp<{ cursor: string }>(
      `/whatsapp-public-api-${STAGE}/manager`,
      request
    );
  },

  async resetUserState(
    clientName: string,
    phone: string,
    ops: string
  ): Promise<ApiResponse<{ success: boolean }>> {
    const request: WhatsAppApiRequest = {
      clientName,
      phone,
      verb: ManagerVerbs.ResetUserState,
      ops,
    };

    return apiClient.postWhatsApp<{ success: boolean }>(
      `/whatsapp-public-api-${STAGE}/manager`,
      request
    );
  },

  async resetCursor(
    clientName: string,
    phone: string,
    ops: string
  ): Promise<ApiResponse<{ success: boolean }>> {
    const request: WhatsAppApiRequest = {
      clientName,
      phone,
      verb: ManagerVerbs.ResetCursor,
      ops,
    };

    return apiClient.postWhatsApp<{ success: boolean }>(
      `/whatsapp-public-api-${STAGE}/manager`,
      request
    );
  },

  async getCadastroInfo(
    dbName: string,
    ops: string,
    type: "all" | "individual",
    phoneNumber?: string
  ): Promise<ApiResponse<CadastroInfo>> {
    const payload: any = {
      type,
      dbName,
      ops,
    };

    if (type === "individual" && phoneNumber) {
      payload.phoneNumber = phoneNumber;
    }

    return apiClient.post<CadastroInfo>("/cadastroInfoWA", payload);
  },
};
